var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from "react";
import { Box, Grid, Stack, Typography, FormControl, Select, MenuItem, } from "@mui/material";
import { colors } from "../../Themes/colors";
import { InProgressIcon, SupportManagementIcon, TicketsIcon, TotalAmountIcon, } from "../../components/icons";
import CommonHeader from "../../components/UtilityComponents/commonHeader";
import ModuleTable from "../../components/UtilityComponents/moduleTable";
import { CustomerPortalSupportManagementDataEnum } from "../../config/TableColumns";
import SearchField from "../../components/FormComponents/SearchField";
import { api_service } from "../../api/api_service";
import { api_urls } from "../../api/api_urls";
import { utility } from "../../utils";
import constants from "../../config/constants";
import moment from "moment";
import "moment-timezone";
import useFillViewportHeight from "../../hooks/useFillViewportHeight";
import CommonTablePagination from "../../components/UtilityComponents/commonTablePagination";
import { getCustomerPortalDisplayName } from "../../utils/commonUtilities";
var SupportTicketColumns = [
    {
        label: "Ticket Number",
        apiKey: CustomerPortalSupportManagementDataEnum.TicketId,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Customer",
        apiKey: CustomerPortalSupportManagementDataEnum.Customer,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Portal Name",
        apiKey: CustomerPortalSupportManagementDataEnum.PortalName,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Subject",
        apiKey: CustomerPortalSupportManagementDataEnum.Subject,
        hasSort: false,
        colDataType: "string",
        tooltipConfig: {
            bgColor: "#333333",
            textColor: "#ffffff",
            fontSize: "13px",
            padding: "10px 12px",
            borderRadius: "6px",
            arrowColor: "#333333",
        },
    },
    {
        label: "Description",
        apiKey: CustomerPortalSupportManagementDataEnum.Description,
        hasSort: false,
        colDataType: "string",
        tooltipConfig: {
            bgColor: "#333333",
            textColor: "#ffffff",
            fontSize: "13px",
            padding: "10px 12px",
            borderRadius: "6px",
            arrowColor: "#333333",
        },
    },
    {
        label: "Date",
        apiKey: CustomerPortalSupportManagementDataEnum.Date,
        hasSort: true,
        colDataType: "date",
    },
    {
        label: "Status",
        apiKey: CustomerPortalSupportManagementDataEnum.Status,
        hasSort: false,
        colDataType: "string",
    },
];
var CustomerPortalSupportManagement = function () {
    var _a = useState([]), supportTickets = _a[0], setSupportTickets = _a[1];
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(1), currentPage = _c[0], setCurrentPage = _c[1];
    var _d = useState(50), recordsPerPage = _d[0], setRecordsPerPage = _d[1];
    var _e = useFillViewportHeight(), tableFillRef = _e.ref, tableFillMaxHeight = _e.maxHeight;
    var _f = useState(0), totalCount = _f[0], setTotalCount = _f[1];
    var _g = useState({
        openTickets: 0,
        inProgress: 0,
        closed: 0,
    }), summaryData = _g[0], setSummaryData = _g[1];
    var _h = useState(null), selectedStatusFilter = _h[0], setSelectedStatusFilter = _h[1];
    var todayDate = moment().format("YYYY-MM-DD");
    var weeklyFromDate = moment().subtract(6, "days").format("YYYY-MM-DD");
    var _j = useState(weeklyFromDate), fromDate = _j[0], setFromDate = _j[1];
    var _k = useState(todayDate), toDate = _k[0], setToDate = _k[1];
    var _l = useState("weekly"), period = _l[0], setPeriod = _l[1];
    var _m = useState(""), searchText = _m[0], setSearchText = _m[1];
    var transformTicketData = function (apiTickets) {
        return apiTickets.map(function (ticket) {
            var statusText = "N/A";
            if (ticket.Status === 1) {
                statusText = "Open";
            }
            if (ticket.Status === 2 || ticket.Status === 3 || ticket.Status === 4) {
                statusText = "In Progress";
            }
            else if (ticket.Status === 5 || ticket.Status === 6) {
                statusText = "Closed";
            }
            return {
                ticketId: ticket.CaseNumber,
                customer: ticket.user
                    ? "".concat(ticket.user.Name)
                    : "N/A",
                subject: ticket.Subject,
                description: ticket.Description,
                date: moment(ticket.CreatedTime).format("MMM D, YYYY"),
                status: statusText,
                portalName: getCustomerPortalDisplayName(ticket.portalName)
            };
        });
    };
    var fetchSupportTickets = function (page, limit) {
        if (page === void 0) { page = 1; }
        if (limit === void 0) { limit = 10; }
        return __awaiter(void 0, void 0, void 0, function () {
            var payload, sortedFilter, response, apiResponse, transformedData, error_1, errorMessage;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        setIsLoading(true);
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, 4, 5]);
                        payload = {
                            page: page,
                            limit: limit,
                        };
                        if (searchText && searchText.trim().length >= 2) {
                            payload.searchTerm = searchText.trim();
                        }
                        if (selectedStatusFilter === null) {
                            payload.status = "All";
                        }
                        else if (selectedStatusFilter === 1) {
                            payload.status = "open";
                        }
                        else if (Array.isArray(selectedStatusFilter)) {
                            sortedFilter = __spreadArray([], selectedStatusFilter, true).sort();
                            if (JSON.stringify(sortedFilter) === JSON.stringify([2, 3, 4])) {
                                payload.status = "inprogress";
                            }
                            else if (JSON.stringify(sortedFilter) === JSON.stringify([5, 6])) {
                                payload.status = "closed";
                            }
                        }
                        if (fromDate) {
                            payload.fromDate = moment(fromDate).format("YYYY-MM-DD");
                        }
                        if (toDate) {
                            payload.toDate = moment(toDate).format("YYYY-MM-DD");
                        }
                        return [4, api_service.get({
                                endPoint: api_urls.CUSTOMER_PORTAL_SUPPORT_TICKET_LIST,
                                payLoad: payload,
                                showLoader: true,
                            })];
                    case 2:
                        response = _d.sent();
                        if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                            apiResponse = response.data;
                            transformedData = transformTicketData(apiResponse.data);
                            setSummaryData({
                                openTickets: apiResponse.openCount,
                                inProgress: apiResponse.inprogressCount || 0,
                                closed: apiResponse.closedCount,
                            });
                            setSupportTickets(transformedData);
                            setTotalCount(apiResponse.totalCount);
                        }
                        else {
                            utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to fetch support tickets", constants.TOAST_TYPES.ERROR);
                        }
                        return [3, 5];
                    case 3:
                        error_1 = _d.sent();
                        console.error("Error fetching support tickets:", error_1);
                        errorMessage = ((_c = (_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                            (error_1 === null || error_1 === void 0 ? void 0 : error_1.message) ||
                            "Failed to fetch support tickets";
                        utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                        return [3, 5];
                    case 4:
                        setIsLoading(false);
                        return [7];
                    case 5: return [2];
                }
            });
        });
    };
    var handlePeriodChange = function (selectedPeriod) {
        setPeriod(selectedPeriod);
        var today = moment().format("YYYY-MM-DD");
        if (selectedPeriod === "day") {
            setFromDate(today);
            setToDate(today);
        }
        else if (selectedPeriod === "weekly") {
            var fromDateStr = moment().subtract(6, "days").format("YYYY-MM-DD");
            setFromDate(fromDateStr);
            setToDate(today);
        }
        else if (selectedPeriod === "monthly") {
            var fromDateStr = moment().subtract(29, "days").format("YYYY-MM-DD");
            setFromDate(fromDateStr);
            setToDate(today);
        }
        else if (selectedPeriod === "yearly") {
            setFromDate(moment().startOf("day").subtract(364, "days").format("YYYY-MM-DD"));
            setToDate(today);
        }
        setCurrentPage(1);
    };
    var handleSearch = function (searchValue) {
        setSearchText(searchValue);
        setCurrentPage(1);
    };
    var isStatusFilterSelected = function (status) {
        if (selectedStatusFilter === null)
            return false;
        if (typeof status === "number") {
            return selectedStatusFilter === status;
        }
        if (Array.isArray(status) && Array.isArray(selectedStatusFilter)) {
            return (JSON.stringify(status.sort()) ===
                JSON.stringify(selectedStatusFilter.sort()));
        }
        return false;
    };
    var isSameStatus = function (a, b) {
        if (Array.isArray(a) && Array.isArray(b)) {
            return a.length === b.length && a.every(function (v, i) { return v === b[i]; });
        }
        return a === b;
    };
    var handleStatusFilterClick = function (status) {
        setSelectedStatusFilter(function (prev) {
            return isSameStatus(prev, status) ? null : status;
        });
        setCurrentPage(1);
    };
    useEffect(function () {
        if (fromDate && toDate) {
            fetchSupportTickets(currentPage, recordsPerPage);
        }
    }, [currentPage, recordsPerPage, period, fromDate, toDate, searchText, selectedStatusFilter]);
    return (React.createElement(Stack, { sx: { p: 3, minHeight: "calc(100dvh - 200px)", gap: 1.5 } },
        React.createElement(Box, { sx: { minHeight: 0 } },
            React.createElement(Stack, { direction: "row", spacing: 2, justifyContent: "space-between", alignItems: "center" },
                React.createElement(CommonHeader, { mainTitle: "Support Management", icon: React.createElement(Box, { sx: { "& svg": { height: 24, width: 24 }, height: 24 } },
                        React.createElement(SupportManagementIcon, null)) }),
                React.createElement(Stack, { direction: "row", spacing: 2, alignItems: "flex-end", flexWrap: "wrap", sx: {
                        mt: 2,
                        "& .MuiInputBase-root": { borderRadius: "8px" },
                    } },
                    React.createElement(Stack, { direction: "row", spacing: 1, alignItems: "center", sx: { marginBottom: "4px !important" } },
                        React.createElement(FormControl, { size: "small", sx: { minWidth: 120 } },
                            React.createElement(Select, { value: period, onChange: function (e) {
                                    handlePeriodChange(e.target.value);
                                }, sx: {
                                    borderRadius: "8px",
                                    bgcolor: "#fff",
                                    height: 36,
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#a3a9b9",
                                    },
                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#a3a9b9",
                                    },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#a3a9b9",
                                        borderWidth: "1px",
                                    },
                                } },
                                React.createElement(MenuItem, { value: "day" }, "Daily"),
                                React.createElement(MenuItem, { value: "weekly" }, "Weekly"),
                                React.createElement(MenuItem, { value: "monthly" }, "Monthly"),
                                React.createElement(MenuItem, { value: "yearly" }, "Yearly")))),
                    React.createElement(Box, { sx: {
                            minWidth: 450,
                            "& .MuiInputBase-root": { bgcolor: "#fff" },
                        } },
                        React.createElement(SearchField, { onSearch: handleSearch, placeholder: "Search By Ticket Number, Customer", value: searchText, debounceTimer: 300 })))),
            React.createElement(Stack, { sx: {
                    "& .summary-cards": {
                        borderRadius: 2,
                        p: 2,
                        height: "100%",
                        "& .summary-cards-icon": {
                            width: 44,
                            height: 44,
                            borderRadius: 1.5,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        },
                    },
                } },
                React.createElement(Grid, { container: true, spacing: 2, sx: { mb: 2, mt: 1 }, alignItems: "flex-start" },
                    React.createElement(Grid, { item: true, xs: 12, sm: 4 },
                        React.createElement(Stack, { className: "summary-cards", onClick: function () { return handleStatusFilterClick(1); }, sx: {
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                                bgcolor: selectedStatusFilter === 1
                                    ? colors.creamPreset[10]
                                    : "#FFFFFF",
                                border: selectedStatusFilter === 1
                                    ? "1px solid ".concat(colors.yellowShades[11])
                                    : "1px solid transparent",
                                "&:hover": {
                                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                    transform: "translateY(-2px)",
                                },
                                "& .summary-cards-icon": {
                                    bgcolor: colors.yellowShades[11],
                                },
                            } },
                            React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 2, justifyContent: "space-between" },
                                React.createElement(Box, null,
                                    React.createElement(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 0.5 } }, "Open Tickets"),
                                    React.createElement(Typography, { variant: "h6", sx: { fontWeight: 600 } }, summaryData.openTickets)),
                                React.createElement(Box, { className: "summary-cards-icon" },
                                    React.createElement(TicketsIcon, null))))),
                    React.createElement(Grid, { item: true, xs: 12, sm: 4 },
                        React.createElement(Stack, { className: "summary-cards", onClick: function () { return handleStatusFilterClick([2, 3, 4]); }, sx: {
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                                bgcolor: isStatusFilterSelected([2, 3, 4])
                                    ? colors.creamPreset[10]
                                    : "#FFFFFF",
                                border: isStatusFilterSelected([2, 3, 4])
                                    ? "1px solid ".concat(colors.yellowShades[11])
                                    : "1px solid transparent",
                                "&:hover": {
                                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                    transform: "translateY(-2px)",
                                },
                                "& .summary-cards-icon": {
                                    bgcolor: colors.yellowShades[11],
                                },
                            } },
                            React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 2, justifyContent: "space-between" },
                                React.createElement(Box, null,
                                    React.createElement(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 0.5 } }, "In Progress Tickets"),
                                    React.createElement(Typography, { variant: "h6", sx: { fontWeight: 600 } }, summaryData.inProgress)),
                                React.createElement(Box, { className: "summary-cards-icon" },
                                    React.createElement(InProgressIcon, null))))),
                    React.createElement(Grid, { item: true, xs: 12, sm: 4 },
                        React.createElement(Stack, { className: "summary-cards", onClick: function () { return handleStatusFilterClick([5, 6]); }, sx: {
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                                bgcolor: isStatusFilterSelected([5, 6])
                                    ? colors.creamPreset[10]
                                    : "#FFFFFF",
                                border: isStatusFilterSelected([5, 6])
                                    ? "1px solid ".concat(colors.yellowShades[11])
                                    : "1px solid transparent",
                                "&:hover": {
                                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                    transform: "translateY(-2px)",
                                },
                                "& .summary-cards-icon": {
                                    bgcolor: colors.yellowShades[11],
                                },
                            } },
                            React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 2, justifyContent: "space-between" },
                                React.createElement(Box, null,
                                    React.createElement(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 0.5 } }, "Resolved Tickets"),
                                    React.createElement(Typography, { variant: "h6", sx: { fontWeight: 600 } }, summaryData.closed)),
                                React.createElement(Box, { className: "summary-cards-icon" },
                                    React.createElement(TotalAmountIcon, null))))))),
            React.createElement(Stack, null,
                React.createElement(Typography, { variant: "body1", sx: { mb: 2, fontWeight: 600 } }, "Support Requests"),
                React.createElement(Box, { className: "common-module-wrapper" },
                    React.createElement(Box, { ref: tableFillRef, className: "module-common-table-wrapper", sx: { marginLeft: '0px !important', marginRight: '0px !important' } },
                        React.createElement(ModuleTable, { dataToDisplay: supportTickets, columns: SupportTicketColumns, isLoading: isLoading, actionHandler: function () { }, isActionColumn: false, isRowClickEnabled: false, activePage: currentPage, recordsPerPage: recordsPerPage, setActivePage: setCurrentPage, setRecordsPerPage: setRecordsPerPage, totalNumberOfRecords: totalCount, customerPoratl: true, tableContainerMaxHeight: tableFillMaxHeight, hidePagination: true }))))),
        React.createElement(Box, { sx: { flexShrink: 0 } },
            React.createElement(CommonTablePagination, { tableData: supportTickets, setCurrentPage: setCurrentPage, setPerPageCount: setRecordsPerPage, currentPage: currentPage, perPageCount: recordsPerPage, totalNumberOfRecords: totalCount }))));
};
export default CustomerPortalSupportManagement;
